import { render, staticRenderFns } from "./garden23.vue?vue&type=template&id=5d566240&scoped=true"
import script from "./garden23.vue?vue&type=script&lang=js"
export * from "./garden23.vue?vue&type=script&lang=js"
import style0 from "./garden23.vue?vue&type=style&index=0&id=5d566240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d566240",
  null
  
)

export default component.exports